<template>
  <div class="eaAreaSurveyTemporary">
    <div class="index-header">
      <span class="title" style="font-size: 14px;">
        <i class="el-icon-caret-right"></i>
        <!-- 物业区域概况 -->
        {{areaProtoy.title}}
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container">
      <div class="box">
        <div class="AreaSurvey">
<!--           <div class="title">{{areaProtoy.title}}</div> -->
          <div class="info-text">
            <div class="info-first">
              <div class="text">
                物业区域
                <span
                  class="num cursor"
                  @click="forwordAlltoarea"
                >{{areaProtoy.areaCount?areaProtoy.areaCount:0}}&nbsp;&nbsp;个</span>
              </div>
              <div class="text">
                物业企业
                <span
                  class="num cursor"
                  @click="forwordtoQueryOrganMge(2,1)"
                >{{areaProtoy.reaCount?areaProtoy.reaCount:0}}&nbsp;&nbsp;个</span>
                <!-- @click="forwordtoarea" -->
              </div>
            </div>
            <div class="info-second">
              <div class="text">
                物业面积
                <span
                  class="num"
                >{{areaProtoy.dimensionsSum?(areaProtoy.dimensionsSum/10000).toFixed(2):0}}&nbsp;&nbsp;万m²</span>
              </div>
              <div class="text">
                业委会
                <span
                  class="num cursor"
                  @click="forwordtoQueryOrganMge(3,2)"
                >{{areaProtoy.ownerCount?areaProtoy.ownerCount:0}}&nbsp;&nbsp;个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              </div>
            </div>
          </div>

          <div class="charts">
            <div @click="forwordtoQueryOrganMge(2,1)" ref="eaarea" style="width:210px;height:150px"></div>
            <div
              @click="forwordtoQueryOrganMge(3,2)"
              ref="generalMeeting"
              style="width:210px;height:150px"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HomeControllerSvr } from "@/service/HomeControllerSvr";
import { mapState } from "vuex";

export default {
  components: {},
  props: { myprop: Boolean },
  data() {
    return {
      areaProtoy: {}
    };
  },
  computed: {
    ...mapState(["token"])
  },
  created() {
    this.HomeControllerSvr = new HomeControllerSvr();
  },
  mounted() {
    this.getdata();
  },
  updated() {
    const arr1 = [this.areaProtoy.areaCount, this.areaProtoy.ownerCount];
    const arr2 = [this.areaProtoy.areaCount, this.areaProtoy.reaCount2];
    this.drawVote(this.$refs.generalMeeting, "成立业委会的小区", arr1);
    this.drawVote(this.$refs.eaarea, "引进物业企业的小区", arr2, "#ffb11a");
  },
  methods: {
    getdata() {
      this.HomeControllerSvr.GetEaAreaGenSit(this.token).then(res => {
        this.areaProtoy = res;
      });
    },
    forwordtoQueryOrganMge(value, type) {
      this.$router.push({
        path: "queryOrganMge",
        query: {
          children: value,
          paramType: type
        }
      });
    },
    forwordAlltoarea() {
      this.$router.push({
        path: "queryPropertyArea"
      });
    },
    forwordtoarea() {
      this.$router.push({
        path: "queryPropertyArea",
        query: {
          option: 2
        }
      });
    },
    jumpMore() {
      this.$router.push({ path: "queryPropertyArea", query: { t:Date.now() } });
    },
    drawVote(dom, name, data, color, option) {
      //投诉统计
      let myChartSatisfaction = this.$echarts.init(dom);
      let partNum = 0;
      // info.CandidateItems._Items.forEach(item => {
      //   partNum += 1;
      // });
      //let percentage = Math.round(partNum / totlNum * 100) + '%';
      let percentage;
      if (parseInt(data[1]) >= 0 && parseInt(data[0]) >= 0) {
        if (parseInt(data[0]) === 0) {
          percentage = "0%";
        } else {
          percentage =
            ((parseInt(data[1]) / parseInt(data[0])) * 100).toFixed(0) + "%";
        }
      } else {
        percentage = "0%";
      }

      //如果大于0不到1%的显示<1%
      if (
        (parseInt(data[1]) / parseInt(data[0])) * 100 > 0 &&
        (parseInt(data[1]) / parseInt(data[0])) * 100 < 1
      ) {
        percentage = "<" + "1%";
      }
      myChartSatisfaction.setOption({
        // tooltip: {
        //   trigger: 'item',
        //   formatter: '{a} <br/>{b}: {c} ({d}%)'
        // },
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: option ? "40px" : "48px",
              z: 2,
              zlevel: 100,
              style: {
                text: percentage,
                x: 100,
                y: 100,
                textAlign: "center",
                fill: "#333333",
                font: '22px "MicrosoftYaHei", sans-serif'
              }
            },
            {
              type: "text",
              left: "center",
              top: option ? "33px" : "115px",
              z: 2,
              zlevel: 100,
              style: {
                text: name,
                x: 100,
                y: 100,
                textAlign: "center",
                fill: "#333333",
                font: '14px "MicrosoftYaHei", sans-serif'
              }
            }
          ]
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["45px", "50px"],
            avoidLabelOverlap: false,
            center: ["50%", "55px"],
            hoverAnimation: false,
            color: [color || "#0f77f2", "#e2e2e2"],
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "15",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: data[1], name: "" },
              { value: data[0] - data[1], name: "" }
            ]
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.eaAreaSurveyTemporary {
  background: #fff;
  .container {
    height: 260px;
    .box {
      width: 100%;
      height: 100%;
      padding: 10px;
      overflow: hidden;
      .AreaSurvey {
        .title {
          position: relative;
          padding-left: 15px;
          font-size: 14px;
          &::after {
            position: absolute;
            left: 8px;
            top: 2px;
            content: "";
            width: 4px;
            height: 10px;
            background: #0f77f2;
          }
        }
        .info-text {
          display: flex;
          .info-first,
          .info-second {
            .text {
              margin-top: 10px;
              padding-left: 8px;
              padding-right: 2px;
              font-size: 12px;
              line-height: 14px;
              .num {
                font-size: 13px;
                font-weight: bold;
                color: #0f77f2;
                float: right;
                &.warn {
                  color: #ff4546;
                }
              }
              .cursor {
                cursor: pointer;
              }
            }
          }
          .info-first {
            width: 46%;
            .text {
              border-right: 1px solid #afafaf;
            }
          }
          .info-second {
            width: 54%;
            .text {
              padding-left: 8px;
            }
          }
        }

        .charts {
          padding-top: 15px;
          display: flex;
          justify-content: space-around;
          .typeTitle {
            margin-top: 16px;
            display: flex;
            flex-direction: row;
            min-width: 200px;
            justify-content: space-around;
            .fontSize {
              display: block;
              height: 14px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: -1px;
              color: #333333;
            }
            .num {
              margin-top: 6px;
              display: block;
              text-align: center;
              margin-right: 3px;
              &.warn {
                color: #ff4546;
              }
            }
          }
        }
        .compared {
          height: 230px;
          padding: 10px;
          .chartBox {
            // border-top: 1px solid #e2e2e2;
            padding-top: 10px;
            .tableInfo {
              margin-top: 12px;
              padding-left: 10px;
              display: flex;
              font-size: 12px;
              color: #333;
              .num {
                font-weight: bold;
              }
            }
          }
        }
      }
      .line {
        width: 1px;
        height: 100%;
        background: #e2e2e2;
      }
    }
  }
}
</style>
